import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface LastMessageSystemProps {
  children: ReactNode;
}

export function LastMessageSystem({ children }: LastMessageSystemProps) {
  return (
    <Box
      className="LastMessagePreviewSystem"
      w="full"
      color="fg.muted"
      fontSize="xs"
      fontWeight="medium"
      lineHeight="normal"
      truncate
    >
      {children}
    </Box>
  );
}
